import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import AttributeEditor from "../../components/attribute/attributeEditor.comp";
import Layout from "../../components/layouts/layout.comp";
import { post } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import { AttributeFormData } from "../../types/attribute";

export default function CreateAttributePage() {
  const { t, msg } = useTranslation();
  const methods = useForm<AttributeFormData>();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: AttributeFormData) => {
      await post("/admin/attribute/create", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["attributes"] });
      push("/attributes");
    },
  });

  return (
    <Layout title={t(msg.attribute.add)}>
      <AttributeEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
